import { render, staticRenderFns } from "./indexFeeDashboard.vue?vue&type=template&id=a1ded008&scoped=true"
import script from "./indexFeeDashboard.vue?vue&type=script&lang=js"
export * from "./indexFeeDashboard.vue?vue&type=script&lang=js"
import style0 from "./indexFeeDashboard.vue?vue&type=style&index=0&id=a1ded008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ded008",
  null
  
)

export default component.exports